import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BasePaxterFilled: React.FC<BaseIconProps> = ({size, color}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 5C2.25 4.58579 2.58579 4.25 3 4.25H9H10H16.1606C17.275 4.25 18.2792 4.92251 18.7035 5.95294L21.6935 13.2144C21.7308 13.305 21.75 13.402 21.75 13.5V18C21.75 18.2224 21.6532 18.4222 21.4994 18.5595C21.4677 20.1889 20.137 21.5 18.5 21.5C16.9273 21.5 15.6373 20.2899 15.5103 18.75H10H9H8.48973C8.36269 20.2899 7.07267 21.5 5.5 21.5C3.84315 21.5 2.5 20.1569 2.5 18.5C2.5 17.2893 3.21724 16.246 4.25 15.772V14.5H3C2.58579 14.5 2.25 14.1642 2.25 13.75V5ZM18.5 20C19.2432 20 19.8602 19.4594 19.9793 18.75C19.9929 18.6687 20 18.5852 20 18.5C20 17.6716 19.3284 17 18.5 17C17.6716 17 17 17.6716 17 18.5C17 18.5852 17.0071 18.6687 17.0207 18.75C17.1398 19.4594 17.7568 20 18.5 20ZM4.25 17.6706C4.09204 17.9081 4 18.1933 4 18.5C4 19.3284 4.67157 20 5.5 20C6.24325 20 6.86024 19.4594 6.97926 18.75C6.9929 18.6687 7 18.5852 7 18.5C7 17.6716 6.32843 17 5.5 17C4.97826 17 4.51873 17.2664 4.25 17.6706ZM10.75 13.75C10.75 13.7926 10.7464 13.8343 10.7396 13.875C10.7464 13.9157 10.75 13.9574 10.75 14V17.25H15.25V15.5C15.25 13.9812 16.4812 12.75 18 12.75H19.8801L17.3165 6.52406C17.1236 6.05569 16.6671 5.75 16.1606 5.75H10.75V13.75Z"
        fill={color}
      />
    </svg>
  );
};
